/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

export const CloseButtonContainer = styled.div`
  background-color: white;
  display: flex;
  justify-content: flex-end;
`;
